module.exports = __webpack_public_path__ + "static/media/trail-dialog.c12c3fc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/index/trail-dialog.png
// module id = 107
// module chunks = 1